import { transformerAnchors, transformerAnchorsFull } from '../../../constants';
import useLayersStore from '../stores/useLayersStore';

/** Clear then attach one node so Konva drops stale multi-select / bbox state. */
export function attachTransformerToSingleNode(tr, node) {
  if (!tr || !node) return;
  tr.nodes([]);
  tr.nodes([node]);
  const image = node.findOne('.main');
  if (image && image.getAttr('elementType') === 'image' && image.getAttr('mode') === 'flex') {
    tr.enabledAnchors(transformerAnchors);
  } else {
    tr.enabledAnchors(transformerAnchorsFull);
  }
  tr.getLayer()?.batchDraw();
}

/**
 * When properties store (selectedGroup) and Transformer diverge — e.g. after nesting via layers DnD —
 * force the transformer to match the logical selection. Clears handles when nothing is selected.
 */
export function syncTransformerToPropertiesSelection(stage, selectedGroup) {
  if (!stage?.findOne) return;
  const tr = stage.findOne('Transformer');
  if (!tr) return;
  // When the properties panel closes, selectedGroup is null but the transformer may stay; do not clear it.
  if (!selectedGroup) {
    return;
  }
  if (selectedGroup.getClassName?.() === 'Transformer') {
    return;
  }
  const cur = tr.nodes();
  if (cur.length !== 1 || cur[0] !== selectedGroup) {
    attachTransformerToSingleNode(tr, selectedGroup);
  }
}

/**
 * Mirrors GraphicLayersPanel.findRelativeNodes: ids used for "related" highlight in the tree
 * (parent group + siblings, or selected node + direct Konva children).
 */
function collectDescendantIds(node) {
  const ids = [node._id];
  node.children?.forEach((child) => ids.push(...collectDescendantIds(child)));
  return ids;
}

export function getLayerRelativeIdsForSelectedNodes(nodes) {
  if (!nodes?.length) return [];
  return nodes.flatMap((node) => {
    if (!node) return [];
    const relatives = [];

    if (node.parent?.attrs?.elementType === 'group') {
      const parent = node.parent;
      relatives.push(parent._id);
      parent.children?.forEach((child) => relatives.push(...collectDescendantIds(child)));
    }

    if (node.children?.length) {
      relatives.push(node._id);
      node.children.forEach((child) => relatives.push(...collectDescendantIds(child)));
    }

    return relatives;
  });
}

/** Keep layers store aligned with the canvas Transformer (keys + relatives). */
export function syncLayersStoreFromTransformer(stage) {
  if (!stage?.findOne) return;
  const tr = stage.findOne('Transformer');
  if (!tr) return;
  const selectedNodes = tr.nodes() || [];
  const keys = selectedNodes.map((o) => o._id);
  const { setSelectedKeys, setSelectedRelatives } = useLayersStore.getState();
  setSelectedKeys(keys);
  setSelectedRelatives(getLayerRelativeIdsForSelectedNodes(selectedNodes));
}
